
// ... import all other images

export default [
      'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC1.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC8.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC10.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC4.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC2.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC7.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC3.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC5.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC9.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Madeline+Caleb/MC6.webp'

];